import { useMemo } from 'react';
import { getFileProgressStats, buildVirtualTaskForProgress } from '../utils/taskUtils';

/**
 * Returns file progress stats and a virtual task (leaf tasks as subtasks) for use with ProgressIndicator.
 * Use when displaying progress for a file's tasks (e.g. in FileName header or save dialog).
 * @param {Array} tasks - List of tasks (typically for the current file)
 * @param {string|null} fileId - Current file id, or null to skip computation
 * @param {{ virtualTaskId?: string }} [options] - Optional. virtualTaskId for the virtual task (default 'file-virtual-task')
 * @returns {{ fileStats: object|null, virtualTask: object|null }}
 */
export function useFileProgress(tasks, fileId, options = {}) {
  const { virtualTaskId = 'file-virtual-task' } = options;

  const fileStats = useMemo(
    () => getFileProgressStats(tasks, fileId),
    [tasks, fileId]
  );

  const virtualTask = useMemo(
    () => (fileStats ? buildVirtualTaskForProgress(tasks, fileId, fileStats, virtualTaskId) : null),
    [tasks, fileId, fileStats, virtualTaskId]
  );

  return { fileStats, virtualTask };
}
